import { useLoadingText } from "features/data-management/workspace/workspace/useLoadingText"
import { ActivitySeriesTotal } from "./useActivityData"

const Tile = ({ label, color, value }: { label: string; color: string; value: string }) => (
    <div className="flex flex-1 min-w-fit gap-4 p-5">
        <div className="w-1 rounded-full shrink-0" style={{ backgroundColor: color }} />
        <div className="flex flex-col gap-1">
            <small className="text-gray-400 mono">{label}</small>
            <div className="text-white text-2xl telegraf">{value}</div>
        </div>
    </div>
)

export const ActivityStatTiles = ({
    totals,
    isLoading,
}: {
    totals: ActivitySeriesTotal[]
    isLoading: boolean
}) => {
    const loadingText = useLoadingText(isLoading)

    return (
        <div className="flex flex-wrap items-stretch rounded-xl overflow-hidden">
            {totals.map((series) => (
                <Tile
                    key={series.key}
                    label={series.label}
                    color={series.color}
                    value={isLoading ? loadingText : `${series.total}`}
                />
            ))}
        </div>
    )
}
